import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Lighter({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = 1,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 15 15' {...props}>
      <Path
        d='M9.147 10.458H5.609'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d={
          'M5.422 10.295a3.357 3.357 0 1 1 3.87 0 .575.575 0 0 0-.256.467v1.548a1.399 1.399 0 0 1-1.399 1.4h-.56' +
          'a1.399 1.399 0 0 1-1.399-1.4v-1.544a.575.575 0 0 0-.256-.47v0Z'
        }
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M.499 7.364h.528M7.372.499v.528M2.51 2.502l.38.38M13.703 7.367h.528M11.838 2.883l.38-.38'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Lighter.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Lighter
